import PixagriScopes from "../../core/models/PixagriScopes";
import { BasePixagriApiService } from "../../core/services/BasePixagriApiService";
import Customer from "../models/Customer";

class PixagriUserApiService extends BasePixagriApiService {

    USER_PARAM_KEY = "userId"
    USER_PARAM = `:${this.USER_PARAM_KEY}`;


    getUpateUserUrl(userId: string): string {
        return `${this.getPixagriRootApiUrl()}/${PixagriScopes.USERS}/${userId}`;
    }
    async updateUser(token: string, userId: string, user: any): Promise<Customer> {
        const url = this.getUpateUserUrl(userId);
        const res = await this.sendRequest<Customer>(token, url, 'POST', user, true);
        if (res.error) {
            throw new Error(`Error updating user: ${res.error}`);
        }
        return res.response;
    }

}

const pixagriUsersApiService = new PixagriUserApiService();
export default pixagriUsersApiService;
